import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { TextField, Box, Typography } from '@mui/material';

const EmployerSearchBox = function EmployerSearchBox({ value, onChange }) {
  const intl = useIntl();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%"
      }}>
      <Typography sx={{ fontSize: '14px' }}>
        {intl.messages.EMPLOYER}:
      </Typography>
      <TextField
        id="employer-searchbox"
        value={value}
        onChange={onChange}
        placeholder={`${intl.messages.INSERT} ${intl.messages.EMPLOYER}`}
        fullWidth
      />
    </Box>
  );
};

EmployerSearchBox.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EmployerSearchBox;
